var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9915 2.57373C5.3915 2.57373 1.6665 6.30706 1.6665 10.9071C1.6665 15.5071 5.3915 19.2404 9.9915 19.2404C14.5998 19.2404 18.3332 15.5071 18.3332 10.9071C18.3332 6.30706 14.5998 2.57373 9.9915 2.57373ZM9.99984 17.5737C6.3165 17.5737 3.33317 14.5904 3.33317 10.9071C3.33317 7.22373 6.3165 4.2404 9.99984 4.2404C13.6832 4.2404 16.6665 7.22373 16.6665 10.9071C16.6665 14.5904 13.6832 17.5737 9.99984 17.5737ZM9.8165 6.7404H9.7665C9.43317 6.7404 9.1665 7.00706 9.1665 7.3404V11.2737C9.1665 11.5654 9.3165 11.8404 9.57484 11.9904L13.0332 14.0654C13.3165 14.2321 13.6832 14.1487 13.8498 13.8654C14.0248 13.5821 13.9332 13.2071 13.6415 13.0404L10.4165 11.1237V7.3404C10.4165 7.00706 10.1498 6.7404 9.8165 6.7404Z",
    fill: "#6138F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.1addf2a63a19e4af17a5fe3be6c24e77.svg";
export { ForwardRef as ReactComponent };